package ru.villawonka.app.domain.usecase

import ru.villawonka.app.domain.model.PostTypeDomain

class RequestSearchCategoriesUseCase {

    operator fun invoke(): Set<PostTypeDomain> = setOf(
        PostTypeDomain.ACCOMMODATION,
        PostTypeDomain.TRANSPORT,
        PostTypeDomain.MONEY_EXCHANGE,
        PostTypeDomain.VISA_AGENCY
    )
}